import SidebarLayout from 'layouts/SidebarLayout';
import {useNavigate} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Tag} from 'letrus-ui';
import {Button} from 'components/ui';
import Character from 'assets/images/characters/CarolinaMariadeJesus/default-happily.webp';
import {useState} from 'react';
import {
  fetchRecommendationsRequest,
  updateRecommendationRequest,
} from 'APIs/letrusAPI/recommendations';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import {getUserData} from 'utils/functions/getUserData/getUserData';
import styles from './Recomendations.module.scss';
import LoadingRecommendation from './components/LoadingRecommendation';

enum StatusText {
  pending = 'Novo',
  accepted = 'Finalizado',
}

function RecommendationsPage() {
  const [currentPage, setCurrentPage] = useState(1);

  const navigate = useNavigate();
  const {trackEvent} = useTrackEvent();

  const recommendationList = fetchRecommendationsRequest({}, currentPage);
  const {userRole} = getUserData();

  const updateRecommendation = updateRecommendationRequest();

  const hasMultiplePages = recommendationList.data?.next;
  const recommendations = recommendationList.data?.results;

  function handleRecommendationClick(
    questionnaireId?: number,
    recommendationId?: number,
  ) {
    updateRecommendation.trigger({id: recommendationId, status: 'accepted'});
    navigate(`/atividades/pesquisa/${questionnaireId}`);
  }

  return (
    <SidebarLayout>
      <main className={styles.container}>
        <header className={styles.header}>
          <button
            type="button"
            onClick={() => {
              navigate(-1);
            }}
            className={styles.goBackButton}
            aria-label="Voltar"
          >
            <FontAwesomeIcon icon="chevron-left" color="#FF4410" size="2x" />
          </button>

          <div className={styles.titleContainer}>
            <h1 className={styles.title}>Exercícios Recomendados</h1>

            <p className={styles.subtitle}>
              Os exercícios recomendados abaixo podem ajudar a melhorar sua
              escrita e a compreensão de textos.
            </p>
          </div>
        </header>

        <section className={styles.recommendationsList}>
          {recommendations?.map(({id, instance, status}) => (
            <article
              key={instance.id}
              className={styles.recommendation}
              data-status={status}
            >
              <div className={styles.recommendationHeader}>
                <h3 className={styles.recommendationTitle}>
                  {instance.template?.title}
                  <Tag variant="readOnly" text={StatusText[status]} />
                </h3>
                <p className={styles.recommendationSubtitle}>
                  {instance.template?.description}
                </p>
              </div>

              {status === 'pending' && (
                <Button
                  variant="primary"
                  size="small"
                  text="Iniciar exercício"
                  onClick={() => {
                    handleRecommendationClick(instance.content_object?.pk, id);
                    trackEvent('clicked_on_recommendation_student', {
                      recommendation: {
                        recommendation_instance_id: instance.id ?? 0,
                        recommendation_userinstance_id: instance?.user ?? 0,
                      },
                      user: {
                        userrole_id: userRole?.id,
                      },
                      network: {
                        network_id: userRole?.school_network_id,
                      },
                      school: {
                        school_id: userRole?.school,
                        schoolgroup_id: userRole?.school_group,
                      },
                    });
                  }}
                />
              )}
            </article>
          ))}

          {recommendationList.isLoading && (
            <>
              <LoadingRecommendation />
              <LoadingRecommendation />
              <LoadingRecommendation />
            </>
          )}

          {recommendations?.length === 0 && (
            <div className={styles.emptyMessage}>
              <figure aria-hidden>
                <img src={Character} alt="Carolina Maria de Jesus" />
              </figure>
              <strong>
                Você não possui nenhuma recomendação no momento. Volte em breve!
              </strong>
            </div>
          )}

          {/* Pagination */}
          {!!recommendations?.length && hasMultiplePages && (
            <div className={styles.seeMore}>
              <Button
                text="Ver mais"
                variant="secondary"
                onClick={() => setCurrentPage((prev) => prev + 1)}
              />
            </div>
          )}
        </section>
      </main>
    </SidebarLayout>
  );
}

export default RecommendationsPage;
